var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobeHemisphereEast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19824 22.9242L7.65797 22.043C7.8046 21.9545 7.92604 21.8298 8.01065 21.6809C8.09525 21.532 8.14019 21.3638 8.14115 21.1926L8.1665 16.6764C8.16756 16.4877 8.22198 16.3032 8.32348 16.1441L10.8038 12.2569C10.8771 12.142 10.9731 12.0433 11.086 11.9669C11.1988 11.8905 11.3261 11.8379 11.46 11.8124C11.5939 11.787 11.7316 11.7892 11.8646 11.8188C11.9976 11.8485 12.1231 11.9051 12.2335 11.985L14.6905 13.7651C14.8986 13.9159 15.1567 13.9808 15.4114 13.9463L19.3464 13.4134C19.5878 13.3807 19.809 13.261 19.9684 13.0768L22.738 9.87672C22.9062 9.68245 22.9931 9.43091 22.9807 9.17428L22.8347 6.13635",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3833 25.4603L22.0419 24.1162C21.9164 23.9905 21.7597 23.9005 21.5879 23.8554L18.9056 23.1515C18.6675 23.089 18.4609 22.9409 18.3252 22.7356C18.1894 22.5302 18.1342 22.2821 18.1701 22.0386L18.4682 20.014C18.4934 19.8432 18.5624 19.6817 18.6685 19.5454C18.7746 19.4091 18.9142 19.3026 19.0737 19.2363L22.88 17.6542C23.0558 17.5811 23.2489 17.5598 23.4364 17.5926C23.624 17.6255 23.7982 17.7112 23.9387 17.8397L27.0505 20.6857",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeHemisphereEast);
export default __webpack_public_path__ + "static/media/GlobeHemisphereEast.8a49671732ae23971f67d59e49fa6523.svg";
export { ForwardRef as ReactComponent };